/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * the base64 response for an asset
 * @export
 * @interface AssetBase64Response
 */
export interface AssetBase64Response {
    /**
     * 
     * @type {string}
     * @memberof AssetBase64Response
     */
    data: string;
}

/**
 * Check if a given object implements the AssetBase64Response interface.
 */
export function instanceOfAssetBase64Response(value: object): value is AssetBase64Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function AssetBase64ResponseFromJSON(json: any): AssetBase64Response {
    return AssetBase64ResponseFromJSONTyped(json, false);
}

export function AssetBase64ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetBase64Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'],
    };
}

export function AssetBase64ResponseToJSON(json: any): AssetBase64Response {
    return AssetBase64ResponseToJSONTyped(json, false);
}

export function AssetBase64ResponseToJSONTyped(value?: AssetBase64Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
    };
}

